import { Delete } from '@mui/icons-material'
import { Typography, styled } from '@mui/material'
import { Link } from 'react-router-dom'

export const DisabledDeleteIcon = styled(Delete)(({ theme }) => ({
  color: `${theme.palette.grey[400]} !important`,
}))

export const UnStyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export const NoUnderlineLink = styled(Link)(() => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
}))

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export const StyledDownloadLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export const StyledMessage = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  padding: '10px',
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
  borderRadius: '4px',
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
}))
